import request from './index'

// 获取内容列表
export function getList(params) {
  return request({
    url: '/contents',
    method: 'get',
    params
  })
}

// 获取内容详情
export function getDetail(id) {
  return request({
    url: '/contents/' + id,
    method: 'get'
  })
}

// 获取某课程及其同组双语版本的两条记录
export function getGroup(id) {
  return request({
    url: '/contents/group/' + id,
    method: 'get'
  })
}

// 新增内容
export function save(data) {
  return request({
    url: '/contents/save',
    method: 'post',
    data
  })
}

// 更新内容
export function update(id, data) {
  return request({
    url: '/contents/update/' + id,
    method: 'post',
    data
  })
}

// 删除内容
export function deleteContent(id) {
  return request({
    url: '/contents/delete/' + id,
    method: 'post'
  })
}

// 基于已有课程创建其配对语言版本
export function createPairContent(id) {
  return request({
    url: '/contents/create-pair/' + id,
    method: 'post'
  })
}

// 上传文件（图片/视频/音频）
export function upload(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/contents/upload',
    method: 'post',
    data: formData,
    timeout: 0,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 上传下载文件（PDF），后端同时入库为素材，使其在素材管理中可见可选
export function uploadDownloadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/contents/upload-download',
    method: 'post',
    data: formData,
    timeout: 0,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
